import { URL_IMAGEN_BASE_URL } from "./variables"

var host = window.location.hostname;
let baseUrl = URL_IMAGEN_BASE_URL


function getURL() {
  if (host === "gdth.cliker.com.mx" || host === "www.gdth.cliker.com.mx") {
    baseUrl = "https://apigdth.cliker.com.mx/";
  } else if (
    host === "mid20dev.pbmg.com.mx" ||
    host === "www.mid20dev.pbmg.com.mx"
  ) {
    baseUrl = "https://apidevmid19.pbmg.com.mx/";
  }
  return baseUrl;
}

const GetUrlImg = {
  getURL,
};

export default GetUrlImg;
